import analytics from '@finn-no/analytics';
import * as careerTypes from '@finn-no/redux-career/actions/types';
import {
    CAREER_FUNNEL_STEP,
    CAREER_FUNNEL_EXIT,
    CAREER_MARKET_STEP,
    CAREER_MARKET_EXIT,
} from './analytics-actions';

function sendEvent(analyticsName, eventFlags, kpi) {
    analytics.trackEvent({
        analyticsName,
        eventFlags,
        kpi,
    });
}

const eventHandlers = {
    [careerTypes.ADD_KEYWORD_PREFERENCE_SUCCESS]: action =>
        analytics.trackEvent({
            analyticsName: `administrate.change-job-keyword-${action.ctx
                .location}.add`,
            stringValue: `keyword: ${action.keyword}`,
            numberValue: 1,
        }),
    [careerTypes.REMOVE_KEYWORD_PREFERENCE_SUCCESS]: action =>
        analytics.trackEvent({
            analyticsName: `administrate.change-job-keyword-${action.ctx
                .location}.remove`,
            stringValue: `keyword: ${action.keyword}`,
            numberValue: 1,
        }),
    [careerTypes.ADD_GEO_REGION_PREFERENCE_SUCCESS]: action =>
        analytics.trackEvent({
            analyticsName: `administrate.change-job-location-${action.ctx
                .location}.add`,
            stringValue: `city: ${action.geoRegion.name}`,
            numberValue: 1,
        }),
    [careerTypes.REMOVE_GEO_REGION_PREFERENCE_SUCCESS]: action =>
        analytics.trackEvent({
            analyticsName: `administrate.change-job-location-${action.ctx
                .location}.remove`,
            stringValue: `city: ${action.geoRegion.name}`,
            numberValue: 1,
        }),
    [careerTypes.SAVE_NOTIFICATION_OPTION_SUCCESS]: () =>
        sendEvent(
            'administrate.job-change-notification-preference',
            'start,success'
        ),

    // Pure tracking
    [CAREER_FUNNEL_STEP]: action =>
        sendEvent(
            `administrate.career-funnel-step-${action.step}`,
            'start,success'
        ),
    [CAREER_FUNNEL_EXIT]: action =>
        sendEvent(
            `administrate.career-funnel-exit-${action.step}`,
            'start,success'
        ),
    [CAREER_MARKET_STEP]: action =>
        sendEvent(
            `administrate.career-funnel-frontpage-step${action.step}.show`,
            action.step === 1 ? 'start' : 'success'
        ),
    [CAREER_MARKET_EXIT]: () =>
        sendEvent('administrate.career-funnel-frontpage-exit.exit'),
};

export default () => next => action => {
    if (eventHandlers[action.type]) {
        eventHandlers[action.type](action);
    }
    return next(action);
};



// WEBPACK FOOTER //
// ./analytics-middleware.js